import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'

import { RootState } from '@Root/slices'
import {
  fetchMyhouseRegister,
  fetchHouse,
  fetchPrivacy,
  fetchMyHouseExist,
  updateDealAmount,
  updatePrivacyCollectUsage,
  updatePyeong,
  updateRealestateType,
  updateRentAmount,
  updateSearchAddress,
  updateTradeDate,
  updateInitTradeDate,
  updateTradeEndDate,
  updateInitTradeEndDate,
  updateTradeType,
  updateWarrantyAmount,
} from '@Root/slices/myhouse/myhouseRegister'
import MyhouseRegisterBuildingHo from '@Types/inner/myhouse/MyhouseRegisterBuildingHo'
import ComplexPyeong from '@Types/entities/ComplexPyeong'
import Address from '@Types/entities/Address'

export default function useMyhouseRegister() {
  const dispatch = useDispatch()
  const myhouseRegister = useSelector((state: RootState) => state.myhouseRegister)

  const setRealestateType = useCallback(
    (value: string) => {
      dispatch(updateRealestateType(value))
    },
    [dispatch],
  )
  const setPyeong = useCallback(
    (param: { pyeongName: string; pyeongNo?: number }) => {
      dispatch(updatePyeong(param))
    },
    [dispatch],
  )
  const setTradeType = useCallback(
    (value: string) => {
      dispatch(updateTradeType(value))
    },
    [dispatch],
  )
  const setDealAmount = useCallback(
    (value: number) => {
      dispatch(updateDealAmount(value))
    },
    [dispatch],
  )
  const setWarrantyAmount = useCallback(
    (value: number) => {
      dispatch(updateWarrantyAmount(value))
    },
    [dispatch],
  )
  const setRentAmount = useCallback(
    (value: number) => {
      dispatch(updateRentAmount(value))
    },
    [dispatch],
  )
  const setTradeDate = useCallback(
    (value: string) => {
      dispatch(updateTradeDate(value))
    },
    [dispatch],
  )
  const setTradeEndDate = useCallback(
    (value: string) => {
      dispatch(updateTradeEndDate(value))
    },
    [dispatch],
  )
  const setInitTradeDate = useCallback(() => {
    dispatch(updateInitTradeDate())
  }, [dispatch])
  const setInitTradeEndDate = useCallback(() => {
    dispatch(updateInitTradeEndDate())
  }, [dispatch])
  const setPrivacyCollectUsage = useCallback(
    (value: boolean) => {
      dispatch(updatePrivacyCollectUsage(value))
    },
    [dispatch],
  )
  const setSearchAddress = useCallback(
    (param: { address: Address; buildingHo: MyhouseRegisterBuildingHo; pyeong?: ComplexPyeong }) => {
      dispatch(updateSearchAddress(param))
    },
    [dispatch],
  )
  const loadMyhouseRegister = useCallback(
    (myhouseNo: number) => {
      dispatch(fetchMyhouseRegister(myhouseNo))
    },
    [dispatch],
  )

  const loadHouse = useCallback(
    (houseNo: number, complexNo?: number) => {
      if (houseNo >= 0) {
        dispatch(fetchHouse({ houseNo, complexNo }))
      }
    },
    [dispatch],
  )

  const loadPrivacy = useCallback(() => {
    dispatch(fetchPrivacy())
  }, [dispatch])

  const loadMyHouseExist = useCallback(() => {
    dispatch(fetchMyHouseExist())
  }, [dispatch])

  return {
    myhouseRegister,
    setPyeong,
    setRealestateType,
    setTradeType,
    setDealAmount,
    setWarrantyAmount,
    setRentAmount,
    setTradeDate,
    setInitTradeDate,
    setTradeEndDate,
    setInitTradeEndDate,
    setPrivacyCollectUsage,
    setSearchAddress,
    loadMyhouseRegister,
    loadHouse,
    loadPrivacy,
    loadMyHouseExist,
  }
}
